import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Helper } from '../helpers/helper';

@Injectable()
export class RegionesService {

  constructor(private http: HttpClient, private helper: Helper) { }

  regiones() {
    return this.http.get(`${this.helper.urlServer}/api/v1/regiones`,
    { headers: this.helper.getHeader(localStorage.getItem('token')) }).map((res: any) => res);
  }

  subRegiones(ID_REGION) {
    console.log(ID_REGION)
    return this.http.get(`${this.helper.urlServer}/api/v1/sub-regiones/${ID_REGION}`,
    { headers: this.helper.getHeader(localStorage.getItem('token')) }).map((res: any) => res);
  }

  registrarEditarRegion(data: any) {
    return this.http.post(`${this.helper.urlServer}/api/v1/registrar-editar-region`, data,
    { headers: this.helper.getHeader(localStorage.getItem('token')) }).map((res: any) => res);
  }

  registrarEditarSubRegion(data: any) {
    return this.http.post(`${this.helper.urlServer}/api/v1/registrar-editar-sub-region`, data,
    { headers: this.helper.getHeader(localStorage.getItem('token')) }).map((res: any) => res);
  }

  removerRegionSubRegion(ID, tipo) {
    return this.http.delete(`${this.helper.urlServer}/api/v1/eliminar-${tipo}`,
    {headers: this.helper.getHeader(localStorage.getItem('token')),
    params: {ID}});
  }
}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/services/regiones.service.ts